// language=GraphQL
export const ALL_PRICINGS_QUERY = `query Query($withAgeGroupSettings: Boolean = false, $withAgeGroupSettingsAgeGroups: Boolean = false, $withCustomDataConfig: Boolean = false, $withCustomDataConfigTravellerForm: Boolean = false, $withCustomDataConfigTravellerFormFields: Boolean = false, $withCustomDataConfigBookingForm: Boolean = false, $withCustomDataConfigBookingFormFields: Boolean = false, $withTravels: Boolean = false, $withTravelsRatioCatalogBundle: Boolean = false, $withTravelsDates: Boolean = false, $withTravelsDatesAvailabilityStatus: Boolean = false, $withTravelsDatesExtensionBaseDate: Boolean = false, $withTravelsDatesExtension: Boolean = false, $withTravelsDatesPackageSettings: Boolean = false, $withTravelsDatesExtensions: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsCapacitySettings: Boolean = false, $withTravelsAccommodationsAddons: Boolean = false, $withTravelsExtensionAccommodations: Boolean = false, $withTravelsFamilyPackages: Boolean = false, $withTravelsFamilyPackagesAccommodation: Boolean = false, $withTravelsFamilyPackagesCapacitySettings: Boolean = false, $withTravelsFamilyPackagesAddons: Boolean = false, $withTravelsPersonalAddons: Boolean = false, $withTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravelsPersonalAddonsCalculationSettings: Boolean = false, $withTravelsPersonalAddonsMandatorySettings: Boolean = false, $withTravelsAccommodationAddons: Boolean = false, $withTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withTravelsBookingAddons: Boolean = false, $withTravelsBookingAddonsCalculationSettings: Boolean = false, $withTravelsBookingAddonsMandatorySettings: Boolean = false, $withTravelsCollectiveAddons: Boolean = false, $withTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withTravelsExtensions: Boolean = false, $withTravelsExtensionsTravelExtension: Boolean = false, $withTravelsExtensionsAccommodationMapItems: Boolean = false, $withTravelsPersonalDiscounts: Boolean = false, $withTravelsPersonalDiscountsMandatorySettings: Boolean = false, $withTravelsBookingDiscounts: Boolean = false, $withTravelsBookingDiscountsMandatorySettings: Boolean = false, $withTravelsCollectiveDiscounts: Boolean = false, $withTravelsCollectiveDiscountsAgeGroupServices: Boolean = false, $withTravelsCollectiveDiscountsMandatorySettings: Boolean = false, $withWebhookConfig: Boolean = false, $withBranding: Boolean = false, $withBrandingLogo: Boolean = false, $withBargainSettings: Boolean = false, $withBargainSettingsBargainTier: Boolean = false, $withEsimSettings: Boolean = false, $withEsimSettingsRegions: Boolean = false, $withPassportConfig: Boolean = false, $withTourOperator: Boolean = false, $withTourOperatorLogo: Boolean = false, $withTourOperatorGtcPdf: Boolean = false, $withCurrencyOverride: Boolean = false, $withCurrencyOverrideCurrency: Boolean = false) {
  pricings: travelPricings {
    id
    ageGroupSettings @include(if: $withAgeGroupSettings) {
      id
      freeUntilAge
      ageGroups @include(if: $withAgeGroupSettingsAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
    isTravelDocumentationAvailable
    customDataConfig @include(if: $withCustomDataConfig) {
      id
      useTravellerForm
      travellerForm @include(if: $withCustomDataConfigTravellerForm) {
        id
        fields @include(if: $withCustomDataConfigTravellerFormFields) {
          id
          inputType
          name
          label
          info
          value
          required
          heading
        }
      }
      useBookingForm
      bookingForm @include(if: $withCustomDataConfigBookingForm) {
        id
        fields @include(if: $withCustomDataConfigBookingFormFields) {
          id
          inputType
          name
          label
          info
          value
          required
          heading
        }
      }
    }
    travels @include(if: $withTravels) {
      id
      ratioCatalogBundle @include(if: $withTravelsRatioCatalogBundle) {
        id
        catalogCode
        travelCode
        json
      }
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      dates @include(if: $withTravelsDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelsDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        isHidden
        includesExtension
        extensionBaseDate @include(if: $withTravelsDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
        extension @include(if: $withTravelsDatesExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withTravelsDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelsDatesExtensions) {
          id
          label
          info
        }
      }
      accommodations @include(if: $withTravelsAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withTravelsAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withTravelsAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      extensionAccommodations @include(if: $withTravelsExtensionAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
      familyPackages @include(if: $withTravelsFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withTravelsFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withTravelsFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withTravelsFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      personalAddons @include(if: $withTravelsPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withTravelsPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withTravelsPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravelsPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      accommodationAddons @include(if: $withTravelsAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withTravelsAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravelsAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      bookingAddons @include(if: $withTravelsBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withTravelsBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravelsBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      collectiveAddons @include(if: $withTravelsCollectiveAddons) {
        id
        label
        info
        ageGroupServices @include(if: $withTravelsCollectiveAddonsAgeGroupServices) {
          id
          ratioServiceNo
        }
        calculationSettings @include(if: $withTravelsCollectiveAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravelsCollectiveAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      extensions @include(if: $withTravelsExtensions) {
        id
        label
        info
        travelExtension @include(if: $withTravelsExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelsExtensionsAccommodationMapItems) {
          id
        }
      }
      personalDiscounts @include(if: $withTravelsPersonalDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withTravelsPersonalDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      bookingDiscounts @include(if: $withTravelsBookingDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withTravelsBookingDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      collectiveDiscounts @include(if: $withTravelsCollectiveDiscounts) {
        id
        label
        info
        ageGroupServices @include(if: $withTravelsCollectiveDiscountsAgeGroupServices) {
          id
          ratioServiceNo
        }
        mandatorySettings @include(if: $withTravelsCollectiveDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      importDateTime
      importStatus
      suppressBusBoardingSelection
    }
    webhookConfig @include(if: $withWebhookConfig) {
      id
      enabled
      url
    }
    branding @include(if: $withBranding) {
      id
      logo @include(if: $withBrandingLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
    }
    bargainSettings @include(if: $withBargainSettings) {
      id
      active
      untilDaysBeforeStart
      bargainTier @include(if: $withBargainSettingsBargainTier) {
        id
        fromPrice
        discount
      }
    }
    esimSettings @include(if: $withEsimSettings) {
      id
      enabled
      regions @include(if: $withEsimSettingsRegions) {
        id
        name
        serviceCodePrefix
      }
    }
    passportConfig @include(if: $withPassportConfig) {
      id
      passportOnly
    }
    tourOperator @include(if: $withTourOperator) {
      id
      name
      url
      logo @include(if: $withTourOperatorLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
      gtcPdf @include(if: $withTourOperatorGtcPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    currencyOverride @include(if: $withCurrencyOverride) {
      id
      enabled
      currency @include(if: $withCurrencyOverrideCurrency) {
        id
        name
        symbol
        code
        isDefault
        exchangeRate
        defaultCountries
      }
      exchangeRate
    }
  }
}`

// language=GraphQL
export const SINGLE_PRICING_QUERY = `query Query($id: ID!, $withAgeGroupSettings: Boolean = false, $withAgeGroupSettingsAgeGroups: Boolean = false, $withCustomDataConfig: Boolean = false, $withCustomDataConfigTravellerForm: Boolean = false, $withCustomDataConfigTravellerFormFields: Boolean = false, $withCustomDataConfigBookingForm: Boolean = false, $withCustomDataConfigBookingFormFields: Boolean = false, $withTravels: Boolean = false, $withTravelsRatioCatalogBundle: Boolean = false, $withTravelsDates: Boolean = false, $withTravelsDatesAvailabilityStatus: Boolean = false, $withTravelsDatesExtensionBaseDate: Boolean = false, $withTravelsDatesExtension: Boolean = false, $withTravelsDatesPackageSettings: Boolean = false, $withTravelsDatesExtensions: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsCapacitySettings: Boolean = false, $withTravelsAccommodationsAddons: Boolean = false, $withTravelsExtensionAccommodations: Boolean = false, $withTravelsFamilyPackages: Boolean = false, $withTravelsFamilyPackagesAccommodation: Boolean = false, $withTravelsFamilyPackagesCapacitySettings: Boolean = false, $withTravelsFamilyPackagesAddons: Boolean = false, $withTravelsPersonalAddons: Boolean = false, $withTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravelsPersonalAddonsCalculationSettings: Boolean = false, $withTravelsPersonalAddonsMandatorySettings: Boolean = false, $withTravelsAccommodationAddons: Boolean = false, $withTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withTravelsBookingAddons: Boolean = false, $withTravelsBookingAddonsCalculationSettings: Boolean = false, $withTravelsBookingAddonsMandatorySettings: Boolean = false, $withTravelsCollectiveAddons: Boolean = false, $withTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withTravelsExtensions: Boolean = false, $withTravelsExtensionsTravelExtension: Boolean = false, $withTravelsExtensionsAccommodationMapItems: Boolean = false, $withTravelsPersonalDiscounts: Boolean = false, $withTravelsPersonalDiscountsMandatorySettings: Boolean = false, $withTravelsBookingDiscounts: Boolean = false, $withTravelsBookingDiscountsMandatorySettings: Boolean = false, $withTravelsCollectiveDiscounts: Boolean = false, $withTravelsCollectiveDiscountsAgeGroupServices: Boolean = false, $withTravelsCollectiveDiscountsMandatorySettings: Boolean = false, $withWebhookConfig: Boolean = false, $withBranding: Boolean = false, $withBrandingLogo: Boolean = false, $withBargainSettings: Boolean = false, $withBargainSettingsBargainTier: Boolean = false, $withEsimSettings: Boolean = false, $withEsimSettingsRegions: Boolean = false, $withPassportConfig: Boolean = false, $withTourOperator: Boolean = false, $withTourOperatorLogo: Boolean = false, $withTourOperatorGtcPdf: Boolean = false, $withCurrencyOverride: Boolean = false, $withCurrencyOverrideCurrency: Boolean = false) {
  pricing: travelPricing(id: $id) {
    id
    ageGroupSettings @include(if: $withAgeGroupSettings) {
      id
      freeUntilAge
      ageGroups @include(if: $withAgeGroupSettingsAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
    isTravelDocumentationAvailable
    customDataConfig @include(if: $withCustomDataConfig) {
      id
      useTravellerForm
      travellerForm @include(if: $withCustomDataConfigTravellerForm) {
        id
        fields @include(if: $withCustomDataConfigTravellerFormFields) {
          id
          inputType
          name
          label
          info
          value
          required
          heading
        }
      }
      useBookingForm
      bookingForm @include(if: $withCustomDataConfigBookingForm) {
        id
        fields @include(if: $withCustomDataConfigBookingFormFields) {
          id
          inputType
          name
          label
          info
          value
          required
          heading
        }
      }
    }
    travels @include(if: $withTravels) {
      id
      ratioCatalogBundle @include(if: $withTravelsRatioCatalogBundle) {
        id
        catalogCode
        travelCode
        json
      }
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      dates @include(if: $withTravelsDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelsDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        isHidden
        includesExtension
        extensionBaseDate @include(if: $withTravelsDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
        extension @include(if: $withTravelsDatesExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withTravelsDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelsDatesExtensions) {
          id
          label
          info
        }
      }
      accommodations @include(if: $withTravelsAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withTravelsAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withTravelsAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      extensionAccommodations @include(if: $withTravelsExtensionAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
      familyPackages @include(if: $withTravelsFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withTravelsFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withTravelsFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withTravelsFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      personalAddons @include(if: $withTravelsPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withTravelsPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withTravelsPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravelsPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      accommodationAddons @include(if: $withTravelsAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withTravelsAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravelsAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      bookingAddons @include(if: $withTravelsBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withTravelsBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravelsBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      collectiveAddons @include(if: $withTravelsCollectiveAddons) {
        id
        label
        info
        ageGroupServices @include(if: $withTravelsCollectiveAddonsAgeGroupServices) {
          id
          ratioServiceNo
        }
        calculationSettings @include(if: $withTravelsCollectiveAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravelsCollectiveAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      extensions @include(if: $withTravelsExtensions) {
        id
        label
        info
        travelExtension @include(if: $withTravelsExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelsExtensionsAccommodationMapItems) {
          id
        }
      }
      personalDiscounts @include(if: $withTravelsPersonalDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withTravelsPersonalDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      bookingDiscounts @include(if: $withTravelsBookingDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withTravelsBookingDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      collectiveDiscounts @include(if: $withTravelsCollectiveDiscounts) {
        id
        label
        info
        ageGroupServices @include(if: $withTravelsCollectiveDiscountsAgeGroupServices) {
          id
          ratioServiceNo
        }
        mandatorySettings @include(if: $withTravelsCollectiveDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
      importDateTime
      importStatus
      suppressBusBoardingSelection
    }
    webhookConfig @include(if: $withWebhookConfig) {
      id
      enabled
      url
    }
    branding @include(if: $withBranding) {
      id
      logo @include(if: $withBrandingLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
    }
    bargainSettings @include(if: $withBargainSettings) {
      id
      active
      untilDaysBeforeStart
      bargainTier @include(if: $withBargainSettingsBargainTier) {
        id
        fromPrice
        discount
      }
    }
    esimSettings @include(if: $withEsimSettings) {
      id
      enabled
      regions @include(if: $withEsimSettingsRegions) {
        id
        name
        serviceCodePrefix
      }
    }
    passportConfig @include(if: $withPassportConfig) {
      id
      passportOnly
    }
    tourOperator @include(if: $withTourOperator) {
      id
      name
      url
      logo @include(if: $withTourOperatorLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
      gtcPdf @include(if: $withTourOperatorGtcPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    currencyOverride @include(if: $withCurrencyOverride) {
      id
      enabled
      currency @include(if: $withCurrencyOverrideCurrency) {
        id
        name
        symbol
        code
        isDefault
        exchangeRate
        defaultCountries
      }
      exchangeRate
    }
  }
}`

// language=GraphQL
export const CREATE_PRICING_MUTATION = `
  mutation Mutation($input: CreateTravelPricingInput, $withAgeGroupSettings: Boolean = false, $withAgeGroupSettingsAgeGroups: Boolean = false, $withCustomDataConfig: Boolean = false, $withCustomDataConfigTravellerForm: Boolean = false, $withCustomDataConfigTravellerFormFields: Boolean = false, $withCustomDataConfigBookingForm: Boolean = false, $withCustomDataConfigBookingFormFields: Boolean = false, $withTravels: Boolean = false, $withTravelsRatioCatalogBundle: Boolean = false, $withTravelsDates: Boolean = false, $withTravelsDatesAvailabilityStatus: Boolean = false, $withTravelsDatesExtensionBaseDate: Boolean = false, $withTravelsDatesExtension: Boolean = false, $withTravelsDatesPackageSettings: Boolean = false, $withTravelsDatesExtensions: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsCapacitySettings: Boolean = false, $withTravelsAccommodationsAddons: Boolean = false, $withTravelsExtensionAccommodations: Boolean = false, $withTravelsFamilyPackages: Boolean = false, $withTravelsFamilyPackagesAccommodation: Boolean = false, $withTravelsFamilyPackagesCapacitySettings: Boolean = false, $withTravelsFamilyPackagesAddons: Boolean = false, $withTravelsPersonalAddons: Boolean = false, $withTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravelsPersonalAddonsCalculationSettings: Boolean = false, $withTravelsPersonalAddonsMandatorySettings: Boolean = false, $withTravelsAccommodationAddons: Boolean = false, $withTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withTravelsBookingAddons: Boolean = false, $withTravelsBookingAddonsCalculationSettings: Boolean = false, $withTravelsBookingAddonsMandatorySettings: Boolean = false, $withTravelsCollectiveAddons: Boolean = false, $withTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withTravelsExtensions: Boolean = false, $withTravelsExtensionsTravelExtension: Boolean = false, $withTravelsExtensionsAccommodationMapItems: Boolean = false, $withTravelsPersonalDiscounts: Boolean = false, $withTravelsPersonalDiscountsMandatorySettings: Boolean = false, $withTravelsBookingDiscounts: Boolean = false, $withTravelsBookingDiscountsMandatorySettings: Boolean = false, $withTravelsCollectiveDiscounts: Boolean = false, $withTravelsCollectiveDiscountsAgeGroupServices: Boolean = false, $withTravelsCollectiveDiscountsMandatorySettings: Boolean = false, $withWebhookConfig: Boolean = false, $withBranding: Boolean = false, $withBrandingLogo: Boolean = false, $withBargainSettings: Boolean = false, $withBargainSettingsBargainTier: Boolean = false, $withEsimSettings: Boolean = false, $withEsimSettingsRegions: Boolean = false, $withPassportConfig: Boolean = false, $withTourOperator: Boolean = false, $withTourOperatorLogo: Boolean = false, $withTourOperatorGtcPdf: Boolean = false, $withCurrencyOverride: Boolean = false, $withCurrencyOverrideCurrency: Boolean = false) {
    pricing: createTravelPricing(input: $input) {
      id
      ageGroupSettings @include(if: $withAgeGroupSettings) {
        id
        freeUntilAge
        ageGroups @include(if: $withAgeGroupSettingsAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      isTravelDocumentationAvailable
      customDataConfig @include(if: $withCustomDataConfig) {
        id
        useTravellerForm
        travellerForm @include(if: $withCustomDataConfigTravellerForm) {
          id
          fields @include(if: $withCustomDataConfigTravellerFormFields) {
            id
            inputType
            name
            label
            info
            value
            required
            heading
          }
        }
        useBookingForm
        bookingForm @include(if: $withCustomDataConfigBookingForm) {
          id
          fields @include(if: $withCustomDataConfigBookingFormFields) {
            id
            inputType
            name
            label
            info
            value
            required
            heading
          }
        }
      }
      travels @include(if: $withTravels) {
        id
        ratioCatalogBundle @include(if: $withTravelsRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withTravelsDates) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withTravelsDatesAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          isHidden
          includesExtension
          extensionBaseDate @include(if: $withTravelsDatesExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
          extension @include(if: $withTravelsDatesExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withTravelsDatesPackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withTravelsDatesExtensions) {
            id
            label
            info
          }
        }
        accommodations @include(if: $withTravelsAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withTravelsAccommodationsCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withTravelsAccommodationsAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        extensionAccommodations @include(if: $withTravelsExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withTravelsFamilyPackages) {
          id
          ratioServiceNo
          accommodation @include(if: $withTravelsFamilyPackagesAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withTravelsFamilyPackagesCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withTravelsFamilyPackagesAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        personalAddons @include(if: $withTravelsPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
          allowedAgeGroups @include(if: $withTravelsPersonalAddonsAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          calculationSettings @include(if: $withTravelsPersonalAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravelsPersonalAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        accommodationAddons @include(if: $withTravelsAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withTravelsAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravelsAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        bookingAddons @include(if: $withTravelsBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withTravelsBookingAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravelsBookingAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        collectiveAddons @include(if: $withTravelsCollectiveAddons) {
          id
          label
          info
          ageGroupServices @include(if: $withTravelsCollectiveAddonsAgeGroupServices) {
            id
            ratioServiceNo
          }
          calculationSettings @include(if: $withTravelsCollectiveAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravelsCollectiveAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        extensions @include(if: $withTravelsExtensions) {
          id
          label
          info
          travelExtension @include(if: $withTravelsExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelsExtensionsAccommodationMapItems) {
            id
          }
        }
        personalDiscounts @include(if: $withTravelsPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
          mandatorySettings @include(if: $withTravelsPersonalDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        bookingDiscounts @include(if: $withTravelsBookingDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
          mandatorySettings @include(if: $withTravelsBookingDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        collectiveDiscounts @include(if: $withTravelsCollectiveDiscounts) {
          id
          label
          info
          ageGroupServices @include(if: $withTravelsCollectiveDiscountsAgeGroupServices) {
            id
            ratioServiceNo
          }
          mandatorySettings @include(if: $withTravelsCollectiveDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        importDateTime
        importStatus
        suppressBusBoardingSelection
      }
      webhookConfig @include(if: $withWebhookConfig) {
        id
        enabled
        url
      }
      branding @include(if: $withBranding) {
        id
        logo @include(if: $withBrandingLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
      }
      bargainSettings @include(if: $withBargainSettings) {
        id
        active
        untilDaysBeforeStart
        bargainTier @include(if: $withBargainSettingsBargainTier) {
          id
          fromPrice
          discount
        }
      }
      esimSettings @include(if: $withEsimSettings) {
        id
        enabled
        regions @include(if: $withEsimSettingsRegions) {
          id
          name
          serviceCodePrefix
        }
      }
      passportConfig @include(if: $withPassportConfig) {
        id
        passportOnly
      }
      tourOperator @include(if: $withTourOperator) {
        id
        name
        url
        logo @include(if: $withTourOperatorLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withTourOperatorGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      currencyOverride @include(if: $withCurrencyOverride) {
        id
        enabled
        currency @include(if: $withCurrencyOverrideCurrency) {
          id
          name
          symbol
          code
          isDefault
          exchangeRate
          defaultCountries
        }
        exchangeRate
      }
    }
  }`

// language=GraphQL
export const UPDATE_PRICING_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingInput, $withAgeGroupSettings: Boolean = false, $withAgeGroupSettingsAgeGroups: Boolean = false, $withCustomDataConfig: Boolean = false, $withCustomDataConfigTravellerForm: Boolean = false, $withCustomDataConfigTravellerFormFields: Boolean = false, $withCustomDataConfigBookingForm: Boolean = false, $withCustomDataConfigBookingFormFields: Boolean = false, $withTravels: Boolean = false, $withTravelsRatioCatalogBundle: Boolean = false, $withTravelsDates: Boolean = false, $withTravelsDatesAvailabilityStatus: Boolean = false, $withTravelsDatesExtensionBaseDate: Boolean = false, $withTravelsDatesExtension: Boolean = false, $withTravelsDatesPackageSettings: Boolean = false, $withTravelsDatesExtensions: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsCapacitySettings: Boolean = false, $withTravelsAccommodationsAddons: Boolean = false, $withTravelsExtensionAccommodations: Boolean = false, $withTravelsFamilyPackages: Boolean = false, $withTravelsFamilyPackagesAccommodation: Boolean = false, $withTravelsFamilyPackagesCapacitySettings: Boolean = false, $withTravelsFamilyPackagesAddons: Boolean = false, $withTravelsPersonalAddons: Boolean = false, $withTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravelsPersonalAddonsCalculationSettings: Boolean = false, $withTravelsPersonalAddonsMandatorySettings: Boolean = false, $withTravelsAccommodationAddons: Boolean = false, $withTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withTravelsBookingAddons: Boolean = false, $withTravelsBookingAddonsCalculationSettings: Boolean = false, $withTravelsBookingAddonsMandatorySettings: Boolean = false, $withTravelsCollectiveAddons: Boolean = false, $withTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withTravelsExtensions: Boolean = false, $withTravelsExtensionsTravelExtension: Boolean = false, $withTravelsExtensionsAccommodationMapItems: Boolean = false, $withTravelsPersonalDiscounts: Boolean = false, $withTravelsPersonalDiscountsMandatorySettings: Boolean = false, $withTravelsBookingDiscounts: Boolean = false, $withTravelsBookingDiscountsMandatorySettings: Boolean = false, $withTravelsCollectiveDiscounts: Boolean = false, $withTravelsCollectiveDiscountsAgeGroupServices: Boolean = false, $withTravelsCollectiveDiscountsMandatorySettings: Boolean = false, $withWebhookConfig: Boolean = false, $withBranding: Boolean = false, $withBrandingLogo: Boolean = false, $withBargainSettings: Boolean = false, $withBargainSettingsBargainTier: Boolean = false, $withEsimSettings: Boolean = false, $withEsimSettingsRegions: Boolean = false, $withPassportConfig: Boolean = false, $withTourOperator: Boolean = false, $withTourOperatorLogo: Boolean = false, $withTourOperatorGtcPdf: Boolean = false, $withCurrencyOverride: Boolean = false, $withCurrencyOverrideCurrency: Boolean = false) {
    pricing: updateTravelPricing(input: $input) {
      id
      ageGroupSettings @include(if: $withAgeGroupSettings) {
        id
        freeUntilAge
        ageGroups @include(if: $withAgeGroupSettingsAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      isTravelDocumentationAvailable
      customDataConfig @include(if: $withCustomDataConfig) {
        id
        useTravellerForm
        travellerForm @include(if: $withCustomDataConfigTravellerForm) {
          id
          fields @include(if: $withCustomDataConfigTravellerFormFields) {
            id
            inputType
            name
            label
            info
            value
            required
            heading
          }
        }
        useBookingForm
        bookingForm @include(if: $withCustomDataConfigBookingForm) {
          id
          fields @include(if: $withCustomDataConfigBookingFormFields) {
            id
            inputType
            name
            label
            info
            value
            required
            heading
          }
        }
      }
      travels @include(if: $withTravels) {
        id
        ratioCatalogBundle @include(if: $withTravelsRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withTravelsDates) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withTravelsDatesAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          isHidden
          includesExtension
          extensionBaseDate @include(if: $withTravelsDatesExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
          extension @include(if: $withTravelsDatesExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withTravelsDatesPackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withTravelsDatesExtensions) {
            id
            label
            info
          }
        }
        accommodations @include(if: $withTravelsAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withTravelsAccommodationsCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withTravelsAccommodationsAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        extensionAccommodations @include(if: $withTravelsExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withTravelsFamilyPackages) {
          id
          ratioServiceNo
          accommodation @include(if: $withTravelsFamilyPackagesAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withTravelsFamilyPackagesCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withTravelsFamilyPackagesAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        personalAddons @include(if: $withTravelsPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
          allowedAgeGroups @include(if: $withTravelsPersonalAddonsAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          calculationSettings @include(if: $withTravelsPersonalAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravelsPersonalAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        accommodationAddons @include(if: $withTravelsAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withTravelsAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravelsAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        bookingAddons @include(if: $withTravelsBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withTravelsBookingAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravelsBookingAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        collectiveAddons @include(if: $withTravelsCollectiveAddons) {
          id
          label
          info
          ageGroupServices @include(if: $withTravelsCollectiveAddonsAgeGroupServices) {
            id
            ratioServiceNo
          }
          calculationSettings @include(if: $withTravelsCollectiveAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravelsCollectiveAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        extensions @include(if: $withTravelsExtensions) {
          id
          label
          info
          travelExtension @include(if: $withTravelsExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelsExtensionsAccommodationMapItems) {
            id
          }
        }
        personalDiscounts @include(if: $withTravelsPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
          mandatorySettings @include(if: $withTravelsPersonalDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        bookingDiscounts @include(if: $withTravelsBookingDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
          mandatorySettings @include(if: $withTravelsBookingDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        collectiveDiscounts @include(if: $withTravelsCollectiveDiscounts) {
          id
          label
          info
          ageGroupServices @include(if: $withTravelsCollectiveDiscountsAgeGroupServices) {
            id
            ratioServiceNo
          }
          mandatorySettings @include(if: $withTravelsCollectiveDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
        importDateTime
        importStatus
        suppressBusBoardingSelection
      }
      webhookConfig @include(if: $withWebhookConfig) {
        id
        enabled
        url
      }
      branding @include(if: $withBranding) {
        id
        logo @include(if: $withBrandingLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
      }
      bargainSettings @include(if: $withBargainSettings) {
        id
        active
        untilDaysBeforeStart
        bargainTier @include(if: $withBargainSettingsBargainTier) {
          id
          fromPrice
          discount
        }
      }
      esimSettings @include(if: $withEsimSettings) {
        id
        enabled
        regions @include(if: $withEsimSettingsRegions) {
          id
          name
          serviceCodePrefix
        }
      }
      passportConfig @include(if: $withPassportConfig) {
        id
        passportOnly
      }
      tourOperator @include(if: $withTourOperator) {
        id
        name
        url
        logo @include(if: $withTourOperatorLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withTourOperatorGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      currencyOverride @include(if: $withCurrencyOverride) {
        id
        enabled
        currency @include(if: $withCurrencyOverrideCurrency) {
          id
          name
          symbol
          code
          isDefault
          exchangeRate
          defaultCountries
        }
        exchangeRate
      }
    }
  }`

// language=GraphQL
export const DELETE_PRICING_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingInput) {
    deleteTravelPricing(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PRICING_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingInput) {
    forceDeleteTravelPricing(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_PRICING_TRAVELS_MUTATION = `
  mutation Mutation($input: addTravelPricingTravelsInput) {
    addTravelPricingTravels(input: $input) {
      id
      travelIds
    }
  }`

// language=GraphQL
export const REMOVE_PRICING_TRAVELS_MUTATION = `
  mutation Mutation($input: removeTravelPricingTravelsInput) {
    removeTravelPricingTravels(input: $input) {
      id
      travelIds
    }
  }`

// language=GraphQL
export const CREATE_PRICING_TRAVELS_MUTATION = `
  mutation Mutation($input: createTravelPricingTravelsInput) {
    createTravelPricingTravels(input: $input) {
      id
      travelIds
    }
  }`

// language=GraphQL
export const DELETE_PRICING_TRAVELS_MUTATION = `
  mutation Mutation($input: deleteTravelPricingTravelsInput) {
    deleteTravelPricingTravels(input: $input) {
      id
      travelIds
    }
  }`

// language=GraphQL
export const PRICINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false) {
  groupedDependents: travelPricingDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
  }
}`
